/**
 * Thin logger wrapper. Keeps the call-site API stable and makes it trivial to
 * silence logs in tests or route them to a third-party (Sentry etc.) later.
 */
export const logger = {
  /** Log informational messages. Suppressed when `import.meta.env.DEV` is false in tests. */
  info: (...args: unknown[]): void => {
    if (import.meta.env.MODE === 'test') return;
    console.info('[stackly]', ...args);
  },
  /** Log warnings. Always emitted. */
  warn: (...args: unknown[]): void => {
    console.warn('[stackly]', ...args);
  },
  /** Log errors. Always emitted. */
  error: (...args: unknown[]): void => {
    console.error('[stackly]', ...args);
  },
};
